module.exports = __webpack_public_path__ + "files/folliot.419ee3370a220f440d7914c83042c6c3.pdf";